import React from 'react';
import * as S from './styles';
import {ReactComponent as Filter} from '../../midia/filter.svg';


export const FiltroParam = ({titulo, ativo}) => {
    return (
      <S.Filtro ativo={ativo}>
          <img src={Filter}></img>
          <span>{titulo}</span>
      </S.Filtro>  
)};
//-----------------------------------------------------
export const FiltroParamSub = (props) => {
    return (
        <S.Filtro>
            <img src={Filter}></img>
            <span>{props.titulo}</span>
        </S.Filtro>  
  )};
